module.exports = __webpack_public_path__ + "static/img/cloud15.b1778da5.png";